import { useCallback, useEffect, useState } from "react";
import { getProductCategories } from "../services/wooCommerceApi";
import { WordPressApiError } from "../services/wordpressClient";
import { isWordPressConfigured } from "../constants/wordpress";

export function useProductCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isWordPressConfigured()) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    getProductCategories()
      .then((data) => {
        if (!cancelled) setCategories(data);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(
            err instanceof WordPressApiError
              ? err.message
              : "Failed to load categories.",
          );
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { categories, loading, error };
}
